import { ArrowRightOutlined, DeleteOutlined } from '@ant-design/icons';
import AttributeModel from '@mm/state/model/AttributeModel';
import { ConnectionVariableModel } from '@mm/state/model/ConnectionVariableModel';
import { selectAttributes } from '@mm/state/selectors/attributeSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PrimarySelect, {
  DropdownOption,
} from '../../../components/PrimarySelect/PrimarySelect';

type Props = {
  connectionVariables: ConnectionVariableModel[];
  variable: ConnectionVariableModel;
  outerOptions: DropdownOption[];
  onDelete: () => void;
  onChange: (updatedField: Partial<ConnectionVariableModel>) => void;
};

export const AttributesMappingRow = ({
  connectionVariables,
  variable,
  outerOptions,
  onDelete,
  onChange,
}: Props) => {
  const attributes = useSelector(selectAttributes);
  const availableAttributes = attributes.filter(
    attr => !connectionVariables?.some(v => v.name === attr.name),
  );

  const [selectedAttribute, setSelectedAttribute] = useState<
    AttributeModel | undefined
  >(attributes.find(a => a.name === variable.name));

  const [selectedOuterAttribute, setSelectedOuterAttribute] = useState<
    DropdownOption | undefined
  >(outerOptions.find(o => o.id === variable.sentAs));

  return (
    <div className="connection-variable-row">
      <PrimarySelect
        className="connection-variable-row__primary-select"
        placeholder="SalesForce Attribute"
        onChange={option => {
          setSelectedOuterAttribute(option);
          onChange({ sentAs: String(option.id) });
        }}
        options={outerOptions}
        value={selectedOuterAttribute}
        customDropdownStyles={{ zIndex: '10000010' }}
        showSearchFilter
      />
      <ArrowRightOutlined className="connection-variable-row__arrow-icon" />
      <PrimarySelect
        className="connection-variable-row__primary-select"
        placeholder="Customers.ai Attribute"
        onChange={(option: AttributeModel) => {
          setSelectedAttribute(option);
          onChange({ name: option.name });
        }}
        options={availableAttributes}
        value={selectedAttribute}
        customDropdownStyles={{ zIndex: '10000010' }}
        showSearchFilter
      />
      <DeleteOutlined
        className="connection-variable-row__trash-icon"
        onClick={onDelete}
      />
    </div>
  );
};
